var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4588 0.000606198C11.7704 0.0139675 11.0856 0.249229 10.5217 0.703382L1.31282 8.08515C0.5339 8.70966 0 9.65614 0 10.7201V22.3273C0 23.7957 1.2066 25.0058 2.67085 25.0058H8.01256H9.79313C9.79313 22.6249 9.79313 20.2439 9.79313 17.863C9.79313 17.3529 10.1748 16.9701 10.6834 16.9701H14.2445C14.7532 16.9701 15.1348 17.3529 15.1348 17.863V25.0058H16.9154H22.2571C23.7213 25.0058 24.928 23.7957 24.928 22.3273V10.7201C24.928 9.67245 24.4317 8.68463 23.5925 8.06073L14.4497 0.649323C14.44 0.641564 14.4302 0.634002 14.4202 0.626652C13.8392 0.194722 13.1471 -0.0127551 12.4588 0.000606198Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNew);
export default __webpack_public_path__ + "static/media/Dashboard_new.32734540afc61335ad510c1b6a532f29.svg";
export { ForwardRef as ReactComponent };